import { DOWNLOAD_BANNER_TYPE, DownloadBannerType } from 'models/Download';
import {
  LISTEN_EVENTS,
  ListenEvents,
} from 'services/socketService/socketEventNames';

type ExportKindConfig = {
  type: DownloadBannerType;
  completedEvent: ListenEvents;
  failedEvent: ListenEvents;
  secondaryCompletedEvent?: ListenEvents;
  secondaryFailedEvent?: ListenEvents;
  inProgressTitleKey?: string;
  inProgressMessageKey?: string;
  failTitleKey?: string;
  usesPdfWindow?: boolean;
  shouldOpenInNewWindow?: boolean;
};

export const EXPORT_KIND_CONFIG: Partial<
  Record<DownloadBannerType, ExportKindConfig>
> = {
  [DOWNLOAD_BANNER_TYPE.ANALYTICS]: {
    type: DOWNLOAD_BANNER_TYPE.ANALYTICS,
    completedEvent: LISTEN_EVENTS.ANALYTICS_EXPORT_COMPLETED,
    failedEvent: LISTEN_EVENTS.ANALYTICS_EXPORT_FAILED,
    inProgressTitleKey: 'exportAlreadyInProgress',
    inProgressMessageKey: 'dataRoomExportInProgressDescription',
    usesPdfWindow: true,
    shouldOpenInNewWindow: true,
  },
  [DOWNLOAD_BANNER_TYPE.LEAD_ANALYTICS]: {
    type: DOWNLOAD_BANNER_TYPE.LEAD_ANALYTICS,
    completedEvent: LISTEN_EVENTS.LEAD_ANALYTICS_EXPORT_COMPLETED,
    failedEvent: LISTEN_EVENTS.LEAD_ANALYTICS_EXPORT_FAILED,
    usesPdfWindow: true,
    shouldOpenInNewWindow: true,
  },
  [DOWNLOAD_BANNER_TYPE.BOSS_MODE]: {
    type: DOWNLOAD_BANNER_TYPE.BOSS_MODE,
    completedEvent: LISTEN_EVENTS.BOSS_MODE_EXPORT_COMPLETED,
    failedEvent: LISTEN_EVENTS.BOSS_MODE_EXPORT_FAILED,
  },
  [DOWNLOAD_BANNER_TYPE.RFI_CATEGORIES]: {
    type: DOWNLOAD_BANNER_TYPE.RFI_CATEGORIES,
    completedEvent: LISTEN_EVENTS.RFI_CATEGORIES_EXPORT_COMPLETED,
    failedEvent: LISTEN_EVENTS.RFI_CATEGORIES_EXPORT_FAILED,
  },
  [DOWNLOAD_BANNER_TYPE.ENTERPRISE_USAGE_REPORT]: {
    type: DOWNLOAD_BANNER_TYPE.ENTERPRISE_USAGE_REPORT,
    completedEvent: LISTEN_EVENTS.ENTERPRISE_USAGE_REPORT_EXPORT_COMPLETED,
    failedEvent: LISTEN_EVENTS.ENTERPRISE_USAGE_REPORT_EXPORT_FAILED,
    failTitleKey: 'reportCouldNotBeGenerated',
    usesPdfWindow: true,
    shouldOpenInNewWindow: true,
  },
  [DOWNLOAD_BANNER_TYPE.REPORT]: {
    type: DOWNLOAD_BANNER_TYPE.REPORT,
    completedEvent: LISTEN_EVENTS.REPORT_PDF_EXPORT_COMPLETED,
    secondaryCompletedEvent: LISTEN_EVENTS.REPORT_CSV_EXPORT_COMPLETED,
    failedEvent: LISTEN_EVENTS.REPORT_PDF_EXPORT_FAILED,
    secondaryFailedEvent: LISTEN_EVENTS.REPORT_CSV_EXPORT_FAILED,
    usesPdfWindow: true,
    shouldOpenInNewWindow: true,
  },
};
